var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoatLandingLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2078,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2886,
    y: -241,
    width: 2078,
    height: 2079
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4467,
    y: -237,
    width: 445,
    height: 475
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4467,
    y: -237,
    width: 445,
    height: 475
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4411,
    y: -264,
    width: 564,
    height: 516
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2886 241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2886,
    y: -241,
    width: 2078,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.463 75.0934C269.264 75.0934 278.918 84.7483 278.918 96.5487 278.918 108.349 269.264 118.004 257.463 118.004 245.663 118.004 236.008 108.349 236.008 96.5487 236.008 84.7483 245.663 75.0934 257.463 75.0934ZM437.151 249.954C436.615 246.199 433.933 242.981 430.714 241.372 427.496 239.763 423.205 240.299 419.987 242.981L359.376 289.646C356.157 291.792 354.548 295.546 355.085 299.837 355.621 303.592 358.303 306.81 361.521 308.419L384.586 318.074C372.249 371.176 327.729 410.868 273.555 417.305L273.555 198.461 407.65 198.461 407.65 166.278 273.555 166.278 273.555 147.505C298.765 139.459 314.32 114.249 310.565 87.9666 306.274 62.2203 283.746 42.9105 257.463 42.9105 231.18 42.9105 208.652 62.2203 204.361 88.503 200.607 114.786 216.162 139.996 241.372 148.041L241.372 166.278 107.276 166.278 107.276 198.461 241.372 198.461 241.372 417.305C187.197 410.332 142.678 370.64 130.341 317.538L153.405 307.883C156.623 306.274 159.305 303.056 159.842 299.301 160.378 295.546 158.769 291.792 155.551 289.646L94.9396 242.981C91.7213 240.835 87.9666 240.299 84.2119 241.372 80.4572 242.981 78.3117 246.199 77.7753 249.954L68.1205 326.12C67.5841 329.875 69.1932 333.629 72.4115 335.775 75.6298 337.92 79.3845 338.457 83.1392 337.384L100.303 330.411C114.786 384.049 156.087 426.96 209.189 443.588L252.099 466.652C255.318 468.261 259.072 468.261 262.291 466.652L305.738 443.051C358.839 426.423 399.604 383.513 414.087 329.875L431.251 337.384C435.005 338.993 438.76 338.457 441.978 335.775 445.197 333.629 446.806 329.875 446.27 326.12L437.151 249.954Z",
    stroke: "#000000",
    strokeWidth: 17.5401,
    transform: "matrix(1.09434 0 0 1 4411.41 -263.811)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatLandingLight);
export default __webpack_public_path__ + "static/media/BoatLandingLight.e24a78bf0d2cf5f9ae4c08308e44a6e7.svg";
export { ForwardRef as ReactComponent };